import React from 'react';
import { FileCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-stone-100 px-5 py-16 sm:py-20" data-id="element-90" data-mp="1o3x4frz4v04n">
      <div className="mx-auto max-w-xl text-center" data-id="element-91" data-mp="1o5q1cfjy25zg">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-red-500" data-id="element-92" data-mp="223og3m26g4fh">
          <FileCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-93" data-mp="1x5d1ky0xt5qx" />
        </span>
        <h2 className="mt-6 text-xl font-black uppercase tracking-wide text-stone-900 sm:text-2xl" data-id="element-94" data-mp="19dzbkyq9dm94">
          Know Exactly What You Receive
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-stone-600" data-id="element-95" data-mp="14dl35fkqwaak">
          Six volumes, 36 practical lessons and five included bonuses.
          Download the English PDFs, choose the next lesson and use the ready-made
          dialogues, worksheets, role cards and teacher keys with your adult learners.
        </p>
      </div>
    </section>;
}